import React from 'react';
import {
  Nav, Navbar,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useParams } from 'react-router-dom';
import styles from './NavBar.module.css';
import { s } from '../../app/helper';
import { useAppSelector } from '../../app/hooks';
import { selectReport } from '../../reducer/reportsSlice';

const NavBar: React.FC = () => {
  const [t] = useTranslation('common');
  const location = useLocation();
  const { reportId } = useParams();

  const report = useAppSelector((state) => selectReport(state, reportId ?? ''));

  return (
    <Navbar bg="transparent" variant="dark" className={styles.navbar}>
      <Nav activeKey={location.pathname} className={styles.navbarNav}>
        <LinkContainer
          to="/report"
        >
          <Navbar.Brand className={styles.navbarLogo}>
            <div className={styles.appname}>{t('title')}</div>
          </Navbar.Brand>
        </LinkContainer>
        <LinkContainer
          to="/intro"
          className={s(styles.navLink, styles.navLinkActive)}
        >
          <Nav.Link>{t('introduction')}</Nav.Link>
        </LinkContainer>
        <LinkContainer
          to="/report"
          className={s(styles.navLink, styles.navLinkActive)}
        >
          <Nav.Link>{t('pick-a-report')}</Nav.Link>
        </LinkContainer>
        {reportId && (
          <span className="border-3 border-top border-bottom border-white p-1 m-1">
            Dokumentencheck |
            {' '}
            {report?.report_name}
          </span>
        )}
      </Nav>
    </Navbar>
  );
};

export default NavBar;
